import { render } from "./MenuMobile.vue?vue&type=template&id=12da946c&scoped=true"
import script from "./MenuMobile.vue?vue&type=script&lang=js"
export * from "./MenuMobile.vue?vue&type=script&lang=js"

import "./MenuMobile.vue?vue&type=style&index=0&id=12da946c&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12da946c"]])

export default __exports__